module.exports = __webpack_public_path__ + "static/img/6.07705a62.png";